import "@fontsource/baloo-2/vietnamese-500.css";
import "@fontsource/baloo-2/vietnamese-700.css";
import "@fontsource/baloo-2/vietnamese-800.css";
import "@fontsource/baloo-2/latin-500.css";
import "@fontsource/baloo-2/latin-700.css";
import "@fontsource/baloo-2/latin-800.css";
import "./styles/app.css";
import "./styles/phase6.css";
import "./styles/ads.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App.tsx";
import { registerServiceWorker } from "./services/update/updates.ts";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Offline shell + update offers for built web versions; dev keeps hot reload predictable.
registerServiceWorker();
